import React from 'react';
import { ArrowDownAZ, ArrowUpZA } from 'lucide-react';

/**
 * Pulsante stile Excel per forzare/togglare ordinamento alfabetico A→Z / Z→A.
 * Va usato in cima alle liste di dipendenti (lavoratori, sorveglianza, formazione, dpi).
 *
 * Props:
 *  - direction: 'asc' | 'desc'
 *  - onToggle:  () => void  → chiamato al click, alterna direction
 *  - label:     etichetta opzionale (default "Ordina")
 *  - testId:    data-testid opzionale
 *  - size:      'sm' | 'md' (default 'sm')
 */
const SortAZButton = ({ direction = 'asc', onToggle, label = 'Ordina', testId, size = 'sm' }) => {
  const isAsc = direction === 'asc';
  const Icon = isAsc ? ArrowDownAZ : ArrowUpZA;
  const arrow = isAsc ? 'A→Z' : 'Z→A';
  const pad = size === 'md' ? 'px-4 py-2 text-xs' : 'px-3 py-1.5 text-[11px]';

  return (
    <button
      type="button"
      onClick={onToggle}
      data-testid={testId || 'sort-az-btn'}
      title={isAsc ? 'Ordinamento A→Z (clicca per invertire in Z→A)' : 'Ordinamento Z→A (clicca per invertire in A→Z)'}
      className={`inline-flex items-center gap-1.5 rounded-full font-bold tracking-wider transition-colors border ${pad} ${
        isAsc
          ? 'bg-emerald-50 border-emerald-200 text-emerald-800 hover:bg-emerald-100'
          : 'bg-amber-50 border-amber-200 text-amber-800 hover:bg-amber-100'
      }`}
    >
      <Icon size={14} />
      <span>{label} {arrow}</span>
    </button>
  );
};

export default SortAZButton;
